// src/firebase.js

// Import only the parts of Firebase you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBoKrMKFW8Xj73k05pNxMlA3lCowTsZbio",
  authDomain: "linkedin-clone-2fccc.firebaseapp.com",
  projectId: "linkedin-clone-2fccc",
  storageBucket: "linkedin-clone-2fccc.firebasestorage.app",
  messagingSenderId: "860529380240",
  appId: "1:860529380240:web:31f0e5bac8e49cb2fa4115",
  measurementId: "G-SWF450H5M0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Access Firestore and Auth
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
